import { render, staticRenderFns } from "./noData.vue?vue&type=template&id=15cd5f79&scoped=true"
import script from "./noData.vue?vue&type=script&lang=js"
export * from "./noData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15cd5f79",
  null
  
)

export default component.exports